import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';

import { IO, IO_AMENDMENT, SIGNED_IO, SIGNED_IO_AMENDMENT } from './constants';

const lastModifiedAsc = (a, b) =>
  new Date(b.lastModified) - new Date(a.lastModified);

const fileTypeLabel = fileType => {
  switch (fileType) {
    case IO:
    case SIGNED_IO:
      return IO;

    case IO_AMENDMENT:
    case SIGNED_IO_AMENDMENT:
      return IO_AMENDMENT;

    default:
      return fileType;
  }
};

export function groupAttachments(attachments) {
  const grouped = groupBy(attachments, file => fileTypeLabel(file.type));

  return mapValues(grouped, files => files.sort(lastModifiedAsc));
}

export function removeFile(attachments, { id, type }) {
  const group = fileTypeLabel(type);
  return {
    ...attachments,
    [group]: attachments[group].filter(file => file.id !== id),
  };
}

export function addFile(attachments, file) {
  const group = fileTypeLabel(file.type);
  const files = [file].concat(attachments[group] || []);
  return { ...attachments, [group]: files };
}
